import { NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'; 
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { ToastrModule } from 'ngx-toastr';

import { HttpClientModule, HttpHeaders } from '@angular/common/http';
import { inject } from '@angular/core';
import { HttpLink } from 'apollo-angular/http';
import { provideApollo } from 'apollo-angular';
import { InMemoryCache } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { environment } from '../environments/environment';
import { SuzukiAppLinkComponent } from './suzuki-app-link/suzuki-app-link.component';



@NgModule({ 
    declarations: [	
        AppComponent,
        SuzukiAppLinkComponent
   ],
    bootstrap: [AppComponent], 
    imports: [BrowserModule, HttpClientModule,
        CommonModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        CoreModule,
        RouterModule,
        FormsModule,
        NgbModule,
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
            closeButton: true,
        })], providers: [
            provideApollo(() => {
                const httpLink = inject(HttpLink);
                const uri = environment.bigQueryUrl;
                const http = httpLink.create({ uri });

                const auth = setContext((_, context) => {
                    let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
                    let headers = new HttpHeaders({
                        'Content-Type': 'application/json; charset=utf-8',
                        'Authorization': `Bearer ${token}`
                    });
                    return { headers };
                });

                return {
                    link: auth.concat(http),
                    cache: new InMemoryCache(),
                };
                }),
        // provideClientHydration(),
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
